import React from "react";
import { CSmartTable } from "@coreui/react-pro";
import PropTypes from "prop-types";
import { IoMdAnalytics } from "react-icons/io";

const Table = ({
  columns,
  usersData,
  selectable,
  SelectedRowsonClick,
  viewClick,
}) => {
  return (
    <div className="my-3">
      <CSmartTable
        activePage={1}
        columns={columns}
        columnSorter
        columnFilter
        items={usersData}
        // itemsPerPageSelect
        itemsPerPage={10}
        pagination
        onFilteredItemsChange={(items) => {
          console.log(items);
        }}
        onSelectedItemsChange={(items) => {
          console.log(items);
          SelectedRowsonClick(items);
        }}
        scopedColumns={{
          Action: (item) => (
            <td>
              {item.Action === "-" ? (
                "-" // show hyphen when Action is "-"
              ) : (
                <button
                  type="button"
                  className="btn btn-outline-success"
                  onClick={() => viewClick(item)}
                >
                  View
                </button>
              )}
            </td>
          ),
        }}
        sorterValue={{ column: "status", state: "asc" }}
        selectable={selectable}
        tableProps={{
          className: "add-this-class text-center fontsize",
          responsive: true,
          striped: true,
          hover: true,
          bordered: true,
        }}
        tableBodyProps={{
          className: "align-middle text-center",
        }}
      />
    </div>
  );
};

Table.propTypes = {
  EditonClick: PropTypes.func.isRequired,
  DeleteonClick: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  usersData: PropTypes.array.isRequired,
  tabellabel: PropTypes.string,
  SelectedRowsonClick: PropTypes.bool,
  checked: PropTypes.bool,
  selectable: PropTypes.func,
};

Table.defaultProps = {
  tabellabel: "",
  onChange: () => {},
  EditonClick: () => {},
  DeleteonClick: () => {},
  SelectedRowsonClick: () => {},
  checked: false,
};

export default Table;
